// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"734":"3016b08e","834":"08704775","856":"381bc72e"}[chunkId] + ".chunk.css";
};